import { L } from '@lang';
import { Placeholder } from '../../shared/ui';
import { ReactComponent as LogoIcon } from '../../shared/assets/logo.svg';

export function Header() {
  return (
    <Placeholder title={L.t('ios_install_pwa_title')} icon={<LogoIcon width={72} height={72} />}>
      {L.t('ios_install_pwa_subtitle')}
    </Placeholder>
  );
}
